export default __webpack_public_path__ + "static/media/IMG_5349.f19bc51b.PNG";